import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { uniqueId } from '../../utils/DomUtils.js';
import { hostClass } from './IconLink.styles.js';
import { IconLinkPresentation } from './IconLinkPresentation.js';

var IconLinkWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(IconLinkWrapper, _React$Component);

  var _super = _createSuper(IconLinkWrapper);

  function IconLinkWrapper(props) {
    var _this;

    _classCallCheck(this, IconLinkWrapper);

    _this = _super.call(this, props);
    _this.iconId = uniqueId("".concat(hostClass, "-"));
    _this.state = {
      hasKeyboardFocus: false,
      hasMouseHover: false
    };
    return _this;
  }

  _createClass(IconLinkWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          hasKeyboardFocus = _this$state.hasKeyboardFocus,
          hasMouseHover = _this$state.hasMouseHover;
      return /*#__PURE__*/React.createElement(IconLinkPresentation, Object.assign({}, this.props, {
        iconId: this.iconId,
        hasKeyboardFocus: hasKeyboardFocus,
        onKeyboardFocusChange: function onKeyboardFocusChange(newFocus) {
          return _this2.setState({
            hasKeyboardFocus: newFocus
          });
        },
        hasMouseHover: hasMouseHover,
        onMouseHoverChange: function onMouseHoverChange(newHover) {
          if (newHover !== _this2.state.hasMouseHover) {
            _this2.setState({
              hasMouseHover: newHover
            });
          }

          _this2.props.onMouseHoverChange(newHover);
        }
      }));
    }
  }]);

  return IconLinkWrapper;
}(React.Component);

IconLinkWrapper.defaultProps = {
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  }
};

export { IconLinkWrapper };
